import React from 'react';
import styled, { css } from 'styled-components';
import { node, bool, string, oneOf, shape } from 'prop-types';
import { C_WHITE, C_EBON } from '@bbc/psammead-styles/colours';
import { GEL_SPACING } from '@bbc/gel-foundations/spacings';
import { getMinion } from '@bbc/gel-foundations/typography';
import { getSansRegular } from '@bbc/psammead-styles/font-styles';
import { scriptPropType } from '@bbc/gel-foundations/prop-types';
import { mediaIcons } from '@bbc/psammead-assets/svgs';

var paddingDir = function paddingDir(_ref) {
  var dir = _ref.dir;
  return "padding-".concat(dir === 'rtl' ? 'left' : 'right');
};

var StyledMediaIndicator = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledMediaIndicator",
  componentId: "sc-1p6h86b-0"
})(["color:", ";background-color:", ";", " ", ";", ""], C_EBON, C_WHITE, function (_ref2) {
  var service = _ref2.service;
  return getSansRegular(service);
}, function (_ref3) {
  var script = _ref3.script;
  return script && getMinion(script);
}, function (_ref4) {
  var isInline = _ref4.isInline;
  return isInline ? css(["display:inline-block;vertical-align:middle;", ":", ";"], paddingDir, GEL_SPACING) : css(["display:block;"]);
});
var FlexWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "FlexWrapper",
  componentId: "sc-1p6h86b-1"
})(["display:flex;align-items:center;height:100%;"]);

var MediaIndicator = function MediaIndicator(_ref5) {
  var type = _ref5.type,
      script = _ref5.script,
      service = _ref5.service,
      dir = _ref5.dir,
      isInline = _ref5.isInline,
      children = _ref5.children;
  return /*#__PURE__*/React.createElement(StyledMediaIndicator, {
    "aria-hidden": "true",
    script: script,
    service: service,
    dir: dir,
    isInline: isInline
  }, /*#__PURE__*/React.createElement(FlexWrapper, null, mediaIcons[type], children));
};

MediaIndicator.propTypes = {
  type: oneOf(['video', 'audio', 'photogallery']),
  script: shape(scriptPropType).isRequired,
  service: string.isRequired,
  dir: oneOf(['ltr', 'rtl']),
  isInline: bool,
  children: node
};
MediaIndicator.defaultProps = {
  type: 'video',
  dir: 'ltr',
  isInline: false,
  children: null
};
export default MediaIndicator;